<template>
  <div>
    <phone-edit />

    <ui-input
      ref="base-mail"
      :value="ACCOUNT.email"
      readonly
      class="profile-contacts__input"
      label="Email*"
      :error="mailError"
    >
      <div v-if="!NEED_TO_CONFIRM_NEW"
        class="edit-icon"
        slot="append"
        @click="isEmailEditOpened = true"
      >
        <f-sprite-icon :icon-link="$options.icons.IconEdit.id" />
      </div>

      <template #after>
        <div class="profile-contacts__input-info" v-if="NEED_TO_CONFIRM_NEW">
          Email остаётся действующим, пока не подтверждён новый
        </div>

        <span class="profile-contacts__resend base"
          v-if="ACCOUNT.email && !IS_EMAIL_CONFIRMED && !NEED_TO_CONFIRM_NEW"
          @click="resendEmail(ACCOUNT.email)"
        >
          Отправить письмо повторно
        </span>
      </template>
    </ui-input>

    <template v-if="NEED_TO_CONFIRM_NEW">
      <ui-input
        ref="new-email"
        :value="UNCONFIRMED_EMAIL"
        readonly
        class="profile-contacts__input"
        label="Новый Email"
        :error="newMailError"
      >
        <div
          class="edit-icon"
          slot="append"
          @click="isEmailEditOpened = true"
        >
          <f-sprite-icon :icon-link="$options.icons.IconEdit.id" />
        </div>

        <template #after v-if="NEED_TO_CONFIRM_NEW">
          <span class="profile-contacts__resend new"
            @click="resendEmail(UNCONFIRMED_EMAIL)"
          >
            Отправить письмо повторно
          </span>
        </template>
      </ui-input>
    </template>

    <modal
      :visible="isEmailEditOpened"
      @on-close="onClose"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <email-edit-form
          v-if="formShown"
          @email-confirmation="onEmailConfirmation"
        />
        <page-info
          v-else
          class="profile-contacts__confirm-info"
          title="Подтвердите изменение Email"
          subtitle="Письмо для подтверждения нового Email  отправлено. Пожалуйста, проверьте почтовый ящик и перейдите по ссылке из письма."
        />
      </transition>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PhoneEdit from '@/components/account/phone-edit.vue';
import EmailEditForm from '@/components/account/email-edit-form';
import PageInfo from '../common/page-info';

/* Icons */
import IconEdit from '@icons/edit.svg';

export default {
  name: 'profile-contacts',

  icons: {
    IconEdit,
  },

  components: {
    PhoneEdit,
    PageInfo,
    EmailEditForm,
  },

  data: () => ({
    isEmailEditOpened: false, // модалка
    formShown: true,
  }),

  computed: {
    ...mapGetters({
      ACCOUNT: 'user/account',
      IS_EMAIL_CONFIRMED: 'user/isEmailConfirmed',
      UNCONFIRMED_EMAIL: 'user/unconfirmedEmail',
      NEED_TO_CONFIRM_NEW: 'user/needToConfirmNew',
    }),

    mailError() {
      return (!this.ACCOUNT.email || this.IS_EMAIL_CONFIRMED) ? '' : 'Email не подтверждён.';
    },
    newMailError() {
      return this.NEED_TO_CONFIRM_NEW ? 'Email не подтверждён.' : '';
    },
  },

  methods: {
    ...mapActions({
      sendConfirmEmail: 'user/sendConfirmEmail',
    }),

    async resendEmail(email) {
      try {
        await this.sendConfirmEmail({ email });
      } catch (error) {
        console.error(error)
      }
    },

    onClose() {
      this.isEmailEditOpened = false;
      this.formShown = true;
    },

    onEmailConfirmation() {
      this.formShown = false;
    }
  },
}
</script>

<style lang="scss">
  .profile-contacts {
    &__resend {
      color: $blue;
      font-size: 12px;
      line-height: 16px;
      cursor: pointer;
    }

    &__input-info {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: $gray;
      margin-bottom: 12px;
      margin-top: 3px;
    }

    &__confirm-info {
      margin: 24px auto;
    }
  }
</style>
